const key = (value) => (value == null ? null : String(value));

export const getFirstLevelProjects = (projects) => {
  if (!Array.isArray(projects)) return [];
  const ids = new Set(projects.map((p) => key(p?.id)));
  return projects.filter((p) => !ids.has(key(p?.parentProjectId)));
};

export const buildProjectIdToFirstLevelId = (projects) => {
  const map = new Map();
  if (!Array.isArray(projects)) return map;

  const byId = new Map(projects.map((p) => [key(p?.id), p]));

  const firstLevelAncestorId = (project) => {
    let current = project;
    const seen = new Set();
    while (current && byId.has(key(current.parentProjectId)) && !seen.has(key(current.id))) {
      seen.add(key(current.id));
      current = byId.get(key(current.parentProjectId));
    }
    return current ? key(current.id) : null;
  };

  projects.forEach((project) => {
    const ancestorId = firstLevelAncestorId(project);
    if (ancestorId != null) map.set(key(project?.id), ancestorId);
  });
  return map;
};

export const resolveFirstLevelId = (map, projectId) => map.get(key(projectId)) ?? key(projectId);

export const getFirstLevelIdSet = (projects) =>
  new Set(getFirstLevelProjects(projects).map((p) => key(p?.id)));

export const resolveDisplayableFirstLevelId = (firstLevelIdSet, projectId) =>
  firstLevelIdSet.has(key(projectId)) ? key(projectId) : null;

// The "Custom Reports" root project is never returned by the projects API, so its id is only known
// as the parent of the first-level folders. With no sub-folder at all there is no parent to read,
// and every workbook in the Custom Reports tree is necessarily filed directly under the root.
export const createRootProjectMatcher = (firstLevelProjects) => {
  const list = Array.isArray(firstLevelProjects) ? firstLevelProjects : [];
  if (list.length === 0) return () => true;
  const rootIds = new Set();
  list.forEach((project) => {
    if (project?.parentProjectId != null) rootIds.add(key(project.parentProjectId));
  });
  return (projectId) => rootIds.has(key(projectId));
};
